import SettingsRoutes from './SettingsRoutes';

/** Settings layout: just the routed page, which owns its own scroll so each
 *  sub-page can pin its own headers / footers.
 *
 *  The Settings sub-nav used to be an in-page sidebar here, and above it a bar
 *  naming the viewer, their role and their region. Both moved to the global
 *  nav panel — the items in BON-531, so settings navigation collapses and
 *  reaches the mobile drawer like every other kind, and the viewer's identity
 *  with them, where the account rows already carry it. The items themselves
 *  live in `shared/nav/config`. */
export default function SettingsPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <main className="min-h-0 flex-1 overflow-y-auto">
        <SettingsRoutes />
      </main>
    </div>
  );
}
